import { fetchData } from "@client";

export async function getWorkspacesQuery() {
  const res = await fetchData(`/workspace?limit=100`);
  
  return res.results;
}
